import english from './en-GB'
import us from './en-US'
import canadian from './en-CA'
import danish from './da-DK'
import german from './de-DE'
import greek from './el-GR'
import spanish from './es-ES'
import finnish from './fi-FI'
import croatian from './hr-HR'
import norwegian from './nb-NO'
import dutch from './nl-NL'
import swedish from './sv-SE'
import french from './fr-FR'
import { hempelProducts } from './hempelproducts'
import { products } from './products'

export default Vue => {
    Object.defineProperties(Vue.prototype, {
        $content: {
            get() {
                return {
                    'en-GB': english,
                    'en-US': us,
                    'en-CA': canadian,
                    'da-DK': danish,
                    'de-DE': german,
                    'el-GR': greek,
                    'es-ES': spanish,
                    'fi-FI': finnish,
                    'hr-HR': croatian,
                    'nb-NO': norwegian,
                    'nl-NL': dutch,
                    'sv-SE': swedish,
                    'fr-FR': french,
                    hempelProducts,
                    products
                }
            }
        }
    })
}
